import { patchState, signalStoreFeature, withHooks, withMethods, withProps, withState } from '@ngrx/signals';
import { inject } from '@angular/core';
import { MemoryCacheItem, MemoryCacheService } from '../cache/memory-cache.service';

export type ConfirmationStatusState = {
  lastOrderID: string;
  retriedOnError: boolean;
  submitId: number;
  _memoryCacheItem: MemoryCacheItem;
};

export const withConfirmationStatusState = (initialValues?: Partial<ConfirmationStatusState>) => {
  return signalStoreFeature(
    withProps(() => ({
      _memoryCacheService: inject(MemoryCacheService),
    })),
    withState({
      submitId: null as number,
      lastOrderID: null as string,
      retriedOnError: null as boolean,
      _memoryCacheItem: null as MemoryCacheItem,
    }),
    withMethods(store => {
      const updateConfirmationStatusStateKeys = (values: Partial<ConfirmationStatusState>) => {
        patchState(store, { ...values });
      };

      return {
        updateConfirmationStatusStateKeys,
      };
    }),
    withHooks(store => {
      const onInit = () => {
        const s = store as unknown as {
          _storageService?: boolean;
        };

        // Check whether the withStorageServiceFeature is initialized before the withConfirmationStatusStateFeature
        if (s?._storageService) {
          throw new Error('withConfirmationStatusStateFeature must be initialized before the withStorageServiceFeature');
        }

        if (!initialValues) return;

        store.updateConfirmationStatusStateKeys(initialValues);
      };
      return {
        onInit,
      };
    }),
  );
};
